import HomeCard from "./Components/HomeCard";
import opsaa from "../../assets/images/logos/opsaalogoazul.png";
import { useTranslation } from "react-i18next";

import atlas from "../../assets/iconos/atlas.svg";
import politicas_publicas from "../../assets/iconos/politicas_publicas.svg";
import marco_normativo from "../../assets/iconos/marcos_normativos.svg";
import vulnerabilidad from "../../assets/iconos/vulnerabilidad.svg";
import comercio from "../../assets/iconos/comercio.svg";
import socioeconomia_ambiente from "../../assets/iconos/socioeconomia_ambiente.svg";

const Opsaa = () => {
    const { t } = useTranslation("translation", { keyPrefix: "opsaa" });

    //TODO: Implementar traduccion, modificar banner y verificar logo opsaa
    return (
        <>
            <div className="row text-center mt-3 mb-3">
                <img
                    src={opsaa}
                    alt="OPSAA-LOGO"
                    style={{ height: "3.5rem", objectFit: "contain" }}
                />
            </div>
            <div className="row text-center mt-1 mb-5 pagetitle">
                <h2>{t('titulo')}</h2>
            </div>
            <div className="row text-center">
                <div className="col-md-4 col-sm-6">
                    <HomeCard
                        type={{
                            type: "info",
                            icon: vulnerabilidad,
                            text: t("vulnerabilidad"),
                        }}
                        navigate="https://opsaa.iica.int/vulnerability"
                        target="_blank"
                    />
                </div>
                <div className="col-md-4 col-sm-6">
                    <HomeCard
                        type={{
                            type: "info",
                            icon: atlas,
                            text: t("atlas"),
                        }}
                        navigate="https://opsaa.iica.int/atlas"
                        target="_blank"
                    />
                </div>
                <div className="col-md-4 col-sm-6">
                    <HomeCard
                        type={{
                            type: "info",
                            icon: socioeconomia_ambiente,
                            text: t("socio_ambiente"),
                        }}
                        navigate="https://opsaa.iica.int/indicators"
                        target="_blank"
                    />
                </div>
                <div className="col-md-4 col-sm-6">
                    <HomeCard
                        type={{
                            type: "info",
                            icon: comercio,
                            text: t("comercio"),
                        }}
                        navigate="https://opsaa.iica.int/commerce"
                        target="_blank"
                    />
                </div>
                <div className="col-md-4 col-sm-6">
                    <HomeCard
                        type={{
                            type: "info",
                            icon: marco_normativo,
                            text: t("politicas"),
                        }}
                        navigate="https://opsaa.iica.int/frames"
                        target="_blank"
                    />
                </div>
                <div className="col-md-4 col-sm-6">
                    <HomeCard
                        type={{
                            type: "info",
                            icon: politicas_publicas,
                            text: t("gasto_publico"),
                        }}
                        navigate="https://opsaa.iica.int/policy-initiatives"
                        target="_blank"
                    />
                </div>
            </div>
        </>
    );
};

export default Opsaa;
